import { EXTERNAL_CHANNEL } from 'src/data/channel';
import { RESOURCE_CONTENT_TYPE } from 'src/data/performance';

import { MESSAGING_BANK_ASSET } from './const';

export const PROMPT_MENU_TYPE = {
  default: 'default',
  url: 'url',
  bank: 'bank',
  image: 'image',
  audio: 'audio',
  video: 'video',
  document: 'document',
  all: 'all',
  salesforce: 'salesforce',
  microsoftDynamicsSales: 'microsoftDynamicsSales',
};

const PROMPT_MENU_TYPE_PROPS = {
  [PROMPT_MENU_TYPE.image]: {
    label: 'Image',
  },
  [PROMPT_MENU_TYPE.url]: {
    label: 'Webpage',
  },
  [PROMPT_MENU_TYPE.bank]: {
    label: MESSAGING_BANK_ASSET,
  },
  [PROMPT_MENU_TYPE.document]: {
    label: 'File (PDF, TXT...)',
  },
  [PROMPT_MENU_TYPE.salesforce]: {
    label: 'Salesforce',
    channel: EXTERNAL_CHANNEL.salesforceCrm,
  },
  [PROMPT_MENU_TYPE.microsoftDynamicsSales]: {
    label: 'Dynamics 365 Sales',
    channel: EXTERNAL_CHANNEL.microsoftDynamicsSales,
  },
  [PROMPT_MENU_TYPE.audio]: {
    label: 'Audio',
  },
  [PROMPT_MENU_TYPE.video]: {
    label: 'Video',
  },
};

export const getPromptMenuTypeLabel = (menuType) => PROMPT_MENU_TYPE_PROPS[menuType]?.label || '';
export const getPromptMenuTypeChannel = (menuType) =>
  PROMPT_MENU_TYPE_PROPS[menuType]?.channel || '';

export const getMenuCards = ({
  hideImages,
  shouldIncludeExternalChannel,
  checkExternalChannelConnected,
  shouldIncludeAudioVideoResources,
}) => {
  let result = [
    {
      type: PROMPT_MENU_TYPE.image,
      label: getPromptMenuTypeLabel(PROMPT_MENU_TYPE.image),
    },
    {
      type: PROMPT_MENU_TYPE.url,
      label: getPromptMenuTypeLabel(PROMPT_MENU_TYPE.url),
    },
    {
      type: PROMPT_MENU_TYPE.bank,
      label: getPromptMenuTypeLabel(PROMPT_MENU_TYPE.bank),
    },
    {
      type: PROMPT_MENU_TYPE.document,
      label: getPromptMenuTypeLabel(PROMPT_MENU_TYPE.document),
    },
  ];

  if (hideImages) {
    result = result.filter((card) =>
      hideImages ? ![PROMPT_MENU_TYPE.image, PROMPT_MENU_TYPE.document].includes(card.type) : true
    );
  }

  if (shouldIncludeAudioVideoResources) {
    result.push(
      {
        type: PROMPT_MENU_TYPE.audio,
        label: getPromptMenuTypeLabel(PROMPT_MENU_TYPE.audio),
      },
      {
        type: PROMPT_MENU_TYPE.video,
        label: getPromptMenuTypeLabel(PROMPT_MENU_TYPE.video),
      }
    );
  }

  if (shouldIncludeExternalChannel) {
    if (checkExternalChannelConnected(EXTERNAL_CHANNEL.salesforceCrm)) {
      result.push({
        type: PROMPT_MENU_TYPE.salesforce,
        label: getPromptMenuTypeLabel(PROMPT_MENU_TYPE.salesforce),
      });
    }
    if (checkExternalChannelConnected(EXTERNAL_CHANNEL.microsoftDynamicsSales)) {
      result.push({
        type: PROMPT_MENU_TYPE.microsoftDynamicsSales,
        label: getPromptMenuTypeLabel(PROMPT_MENU_TYPE.microsoftDynamicsSales),
      });
    }
  }

  return result;
};

const RESOURCE_TYPE_TO_PROMPT_MENU = {
  [RESOURCE_CONTENT_TYPE.url]: PROMPT_MENU_TYPE.url,
  [RESOURCE_CONTENT_TYPE.document]: PROMPT_MENU_TYPE.document,
  [RESOURCE_CONTENT_TYPE.image]: PROMPT_MENU_TYPE.image,
  [RESOURCE_CONTENT_TYPE.audio]: PROMPT_MENU_TYPE.audio,
  [RESOURCE_CONTENT_TYPE.video]: PROMPT_MENU_TYPE.video,
  [RESOURCE_CONTENT_TYPE.messagingBankAsset]: PROMPT_MENU_TYPE.bank,
};

export const resourceTypeToPromptMenuType = (resourceType) =>
  RESOURCE_TYPE_TO_PROMPT_MENU[resourceType];
export const promptMenuTypeToResourceType = (menuType) =>
  Object.keys(RESOURCE_TYPE_TO_PROMPT_MENU).find(
    (key) => RESOURCE_TYPE_TO_PROMPT_MENU[key] === menuType
  );
